import { defineCustomElement } from '@tyler-components-web/core';
import { PageStateComponent } from './page-state';
export * from './page-state-constants';
export * from './page-state';
export function definePageStateComponent() {
    defineCustomElement(PageStateComponent);
}
